import { useEffect, useState } from 'react'

import DigitInput from './digitInput'

interface Props {
    verificationCode: string[]
    onChange: (value: string[]) => void
}

const VerificationCodeInput = (props: Props) => {
    const { verificationCode, onChange } = props

    const maxIndex = verificationCode.length - 1

    const [currentIndex, setCurrentIndex] = useState(0)

    useEffect(() => {
        const emptyVerificationCode = verificationCode.every((codeDigit) => !codeDigit)
        if (emptyVerificationCode) {
            setCurrentIndex(0)
        }
    }, [verificationCode])

    const updateIndex = (index: number) => {
        const sanitizedIndex = index <= 0 ? 0 : index >= maxIndex ? maxIndex : index
        setCurrentIndex(sanitizedIndex)
    }

    const handlePasteCode = (digits: string) => {
        const pastedDigits = digits.slice(0, verificationCode.length).split('')

        const verificationCodeCopy = [...verificationCode]
        pastedDigits.forEach((digit, index) => {
            verificationCodeCopy[index] = digit
        })

        onChange(verificationCodeCopy)
        updateIndex(Math.min(pastedDigits.length, maxIndex))
    }

    return (
        <div data-testid="verification-input" className="flex">
            {verificationCode.map((codeDigit, index) => (
                <DigitInput
                    key={index}
                    value={codeDigit}
                    focus={currentIndex === index}
                    onFocus={() => setCurrentIndex(index)}
                    onMoveFocus={(direction) => {
                        const newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1
                        updateIndex(newIndex)
                    }}
                    onChange={(value) => {
                        const verificationCodeCopy = [...verificationCode]
                        verificationCodeCopy[index] = value

                        onChange(verificationCodeCopy)

                        const newIndex = value ? currentIndex + 1 : currentIndex - 1
                        updateIndex(newIndex)
                    }}
                    onPasteCode={handlePasteCode}
                />
            ))}
        </div>
    )
}

export default VerificationCodeInput
